module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-700-bold-italic-f32b35bae4da9b125be37e53df7867e4.woff2";